import { ReactElement } from "react";
import Modal from "react-bootstrap/Modal";
import { ButtonVariant } from "@telusinternationalai/seibun-ui";

import SeibunButton from "../Button/SeibunButton";

export type WarningModalProps = Readonly<{
  isOpen?: boolean;
  title: string;
  body: string;
  buttonText: string;
  onClose: () => void;
}>;

const WarningModal = ({
  isOpen = false,
  title,
  body,
  buttonText,
  onClose,
}: WarningModalProps): ReactElement => {
  return (
    <Modal title={title} show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{body}</p>
      </Modal.Body>
      <Modal.Footer>
        <SeibunButton
          id="Warning-modal"
          variant={ButtonVariant.NEGATIVE}
          onClick={onClose}
          className="font-weight-normal px-4"
        >
          {buttonText}
        </SeibunButton>
      </Modal.Footer>
    </Modal>
  );
};

export default WarningModal;
